module.exports = __webpack_public_path__ + "img/fmp-brain-original.0c58eb20.svg";